{
  "ping": "Время отклика на ping",
  "date": {
    "seconds": "с.",
    "minutes": "мин.",
    "hours": "час.",
    "days": "д.",
    "weeks": "нед.",
    "months": "мес.",
    "years": "г."
  }
}